import { render } from "./ClientSearchDropdown.vue?vue&type=template&id=55b66fd0&scoped=true"
import script from "./ClientSearchDropdown.vue?vue&type=script&lang=js"
export * from "./ClientSearchDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/whisk/whisk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55b66fd0"]])

export default __exports__